import React from 'react'

const OtherCompanion = () => {
  return (
    <section className='p-8 w-full h-full'>
        <div>
            <h2 className='text-lg lg:text-xl text-center text-gray-600'>Other Companion</h2>
            <div className="card w-[23rem] lg:w-[37rem] h-[9rem] rounded-lg mx-auto my-5 flex flex-col justify-center shadow-xl border-2 p-5 ">
                <h2 className='p-2 font-semibold text-blue-600'>NEET Companion</h2>
                <p className='p-2'>Your one-stop MBBS Counselling package with NEET UG College Predictor, a printed Almanac, Webinars & more</p>
            </div>
        </div>
    </section>
  )
}

export default OtherCompanion
